import { render } from "./PlayerTour.vue?vue&type=template&id=c686db2a&scoped=true"
import script from "./PlayerTour.vue?vue&type=script&lang=js"
export * from "./PlayerTour.vue?vue&type=script&lang=js"

import "./PlayerTour.vue?vue&type=style&index=0&id=c686db2a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c686db2a"]])

export default __exports__